import {
  createService,
  createServiceCommunication,
  deleteServiceCommunication,
  getServiceById,
  getServices,
  updateService,
  updateServiceCommunication
} from '@/store/actions/service'
import { REDUCER_STATE } from '../../constants/store'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  [REDUCER_STATE.SERVICE.FIELDS.IS_GETTING_SERVICES]: false,
  [REDUCER_STATE.SERVICE.FIELDS.IS_CREATING_SERVICE]: false,
  [REDUCER_STATE.SERVICE.FIELDS.IS_GETTING_SERVICE]: false,
  [REDUCER_STATE.SERVICE.FIELDS.IS_UPDATING_SERVICE]: false,
  [REDUCER_STATE.SERVICE.FIELDS.IS_CREATING_SERVICE_COMMUNICATION]: false,
  [REDUCER_STATE.SERVICE.FIELDS.IS_UPDATING_SERVICE_COMMUNICATION]: false,
  [REDUCER_STATE.SERVICE.FIELDS.IS_DELETING_SERVICE_COMMUNICATION]: false,
  [REDUCER_STATE.SERVICE.FIELDS.SERVICES]: [],
  [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: null,
  [REDUCER_STATE.SERVICE.FIELDS.ERROR]: null
}
const reducers = {}
const extraReducers = {
  //get all services
  [getServices.pending]: (state) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: null,
    [REDUCER_STATE.SERVICE.FIELDS.IS_GETTING_SERVICES]: true,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICES]: []
  }),
  [getServices.fulfilled]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.IS_GETTING_SERVICES]: false,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICES]: action.payload
  }),
  [getServices.rejected]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: action.error,
    [REDUCER_STATE.SERVICE.FIELDS.IS_GETTING_SERVICES]: false
  }),
  //get one service
  [getServiceById.pending]: (state) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: null,
    [REDUCER_STATE.SERVICE.FIELDS.IS_GETTING_SERVICE]: true,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: null
  }),
  [getServiceById.fulfilled]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.IS_GETTING_SERVICE]: false,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: action.payload.service
  }),
  [getServiceById.rejected]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: action.error,
    [REDUCER_STATE.SERVICE.FIELDS.IS_GETTING_SERVICE]: false
  }),
  //create service
  [createService.pending]: (state) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: null,
    [REDUCER_STATE.SERVICE.FIELDS.IS_CREATING_SERVICE]: true,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: null
  }),
  [createService.fulfilled]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.IS_CREATING_SERVICE]: false,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: action.payload
  }),
  [createService.rejected]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.IS_CREATING_SERVICE]: false,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: action.error
  }),
  //update service
  [updateService.pending]: (state) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: null,
    [REDUCER_STATE.SERVICE.FIELDS.IS_UPDATING_SERVICE]: true,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: null
  }),
  [updateService.fulfilled]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.IS_UPDATING_SERVICE]: false,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: action.payload
  }),
  [updateService.rejected]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.IS_UPDATING_SERVICE]: false,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: action.error
  }),
  //create service communication
  [createServiceCommunication.pending]: (state) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: null,
    [REDUCER_STATE.SERVICE.FIELDS.IS_CREATING_SERVICE_COMMUNICATION]: true,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: null
  }),
  [createServiceCommunication.fulfilled]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.IS_CREATING_SERVICE_COMMUNICATION]: false,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: action.payload.service
  }),
  [createServiceCommunication.rejected]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.IS_CREATING_SERVICE_COMMUNICATION]: false,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: action.error
  }),
  //update service communication
  [updateServiceCommunication.pending]: (state) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: null,
    [REDUCER_STATE.SERVICE.FIELDS.IS_UPDATING_SERVICE_COMMUNICATION]: true,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: null
  }),
  [updateServiceCommunication.fulfilled]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.IS_UPDATING_SERVICE_COMMUNICATION]: false,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: action.payload.service
  }),
  [updateServiceCommunication.rejected]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.IS_UPDATING_SERVICE_COMMUNICATION]: false,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: action.error
  }),
  //delete service communication
  [deleteServiceCommunication.pending]: (state) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: null,
    [REDUCER_STATE.SERVICE.FIELDS.IS_DELETING_SERVICE_COMMUNICATION]: true,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: null
  }),
  [deleteServiceCommunication.fulfilled]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.IS_DELETING_SERVICE_COMMUNICATION]: false,
    [REDUCER_STATE.SERVICE.FIELDS.SERVICE]: action.payload.service
  }),
  [deleteServiceCommunication.rejected]: (state, action) => ({
    ...state,
    [REDUCER_STATE.SERVICE.FIELDS.IS_DELETING_SERVICE_COMMUNICATION]: false,
    [REDUCER_STATE.SERVICE.FIELDS.ERROR]: action.error
  })
}
const slice = createSlice({
  name: REDUCER_STATE.SERVICE.NAME,
  initialState,
  reducers,
  extraReducers
})

export default slice
